import { z } from 'zod'
import {
  LOAN_ISSUE_SEVERITIES,
  LOAN_ISSUE_SOURCES,
} from '../loans/issues/define.js'
import { LOAN_ISSUE_GROUPS } from '../loans/issues/groups.js'
import { LOAN_ISSUE_SECTIONS } from '../loans/issues/sections.js'
import {
  LOAN_ISSUE_BLOCK_STATUSES,
  LOAN_ISSUE_PHASES,
} from '../loans/issues/phases.js'

export const loanIssueDtoSchema = z.object({
  code: z.string(),
  source: z.enum(LOAN_ISSUE_SOURCES),
  group: z.enum(LOAN_ISSUE_GROUPS),
  section: z.enum(LOAN_ISSUE_SECTIONS),
  fields: z.array(z.string()),
  severity: z.enum(LOAN_ISSUE_SEVERITIES),
  wouldBlock: z.array(z.enum(LOAN_ISSUE_BLOCK_STATUSES)),
  /** Lender staff or an admin may proceed past the block with a reason. */
  overridable: z.boolean(),
  message: z.string(),
})

export type LoanIssueDto = z.infer<typeof loanIssueDtoSchema>

export const loanIssueListDtoSchema = z.object({
  issues: z.array(loanIssueDtoSchema),
  phase: z.enum(LOAN_ISSUE_PHASES).nullable(),
})

export type LoanIssueListDto = z.infer<typeof loanIssueListDtoSchema>
